// extracted by mini-css-extract-plugin
export default {"brand":"Brand_brand__1r4rS"};